'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuex = require('vuex');

var _cart = require('../../components/cart');

var _cart2 = _interopRequireDefault(_cart);

var _StepButton = require('./StepButton');

var _StepButton2 = _interopRequireDefault(_StepButton);

var _StepButtonTint = require('./StepButtonTint');

var _StepButtonTint2 = _interopRequireDefault(_StepButtonTint);

var _vueScrollto = require('vue-scrollto');

var _vueScrollto2 = _interopRequireDefault(_vueScrollto);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = {
  name: "Step3",
  components: {
    StepButton: _StepButton2.default,
    StepButtonTint: _StepButtonTint2.default
  },
  computed: Object.assign({}, (0, _vuex.mapState)({
    finalLens: function finalLens(state) {
      return state.prescription.finalLens;
    },
    finalVariant: function finalVariant(state) {
      return state.prescription.finalVariant;
    },
    options: function options(state) {
      return state.prescription.options;
    },
    frame: function frame(state) {
      return state.prescription.frame;
    },
    activePrescription: function activePrescription(state) {
      return state.prescription.activePrescription;
    },
    tintMeta: function tintMeta(state) {
      return state.prescription.meta.tints;
    },
    optionButtons: function optionButtons(state) {
      return state.prescription.meta.options;
    },
    totalPrice: function totalPrice(state) {
      return state.prescription.totalPrice;
    },
    cancelButton: function cancelButton(state) {
      return state.prescription.cms.global.cancel_button;
    },
    cms: function cms(state) {
      return state.prescription.cms.step3;
    },
    addToCartContent: function addToCartContent(state) {
      return state.prescription.cms.global.add_to_cart;
    }
  }), {
    notTints: function notTints() {
      return this.finalLens.variants.filter(function (variant) {
        return !variant.option1.toLowerCase().trim().includes('tints');
      });
    },
    tints: function tints() {
      var button = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.finalLens.variants[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var tint = _step.value;

          if (tint.option1.toLowerCase().trim().includes('tints')) {
            button.push(tint);
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return button;
    },
    tintMetaVariants: function tintMetaVariants() {
      var meta = this.tintMeta;
      var variants = this.finalLens.variants;
      var returnArray = [];

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = variants[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var variant = _step2.value;

          if (variant.option1.toLowerCase().includes('tints')) {
            (function () {
              var tintColor = variant.option1.split(':')[1].trim().toLowerCase();
              var mappedMeta = meta.filter(function (button) {
                return button.name.trim().toLowerCase() === tintColor;
              })[0];

              if (mappedMeta) {
                Object.assign(mappedMeta, variant);
                returnArray.push(mappedMeta);
              }
            })();
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      console.log(returnArray);
      return returnArray;
    }
  }),
  data: function data() {
    var _JSON$parse = JSON.parse(document.getElementById('ShopifyData').innerHTML),
        customer = _JSON$parse.customer;

    return {
      nextDisabled: true,
      showTints: false,
      selectedTint: '',
      lensProps: { '_item_type': 'specs_lens' },
      customer: customer
    };
  },

  methods: Object.assign({}, (0, _vuex.mapMutations)(['setFinalVariant', 'setFrameOptions']), {
    selectOption: function selectOption(variant) {
      var options = this.options;

      options.step3.name = 'Lens Option: ' + variant.title;
      options.step3.cost = variant.price;
      this.selectedTint = '';

      this.showTints = false;
      this.nextDisabled = false;

      this.setFinalVariant(variant);
      this.setFrameOptions(options);
    },
    selectTintOption: function selectTintOption(button) {
      var options = this.options;

      var element = this.$refs.tints;
      var scrollOptions = { container: '.PrescriptionLensData' };

      this.showTints = true;
      this.nextDisabled = true;

      _vueScrollto2.default.scrollTo(element, 300, scrollOptions);

      options.step3.name = 'Lens Option: Tint';
      options.step3.cost = button.price;

      this.setFinalVariant({ id: 'tint' });
      this.setFrameOptions(options);
    },
    activeOption: function activeOption(id) {
      return this.finalVariant.id && this.finalVariant.id === id;
    },
    inactiveOption: function inactiveOption(id) {
      return this.finalVariant.id && this.finalVariant.id !== id;
    },
    activeTint: function activeTint(name) {
      return this.selectedTint.toLowerCase().trim() === name.toLowerCase().trim();
    },
    inactiveTint: function inactiveTint(name) {
      return this.selectedTint.toLowerCase() && this.selectedTint.toLowerCase().trim() !== name.toLowerCase().trim();
    },
    addToCart: function addToCart() {
      var _this = this;

      var self = this;
      var customer = this.customer;

      var element = document.querySelector('.PrescriptionHeader');
      var options = { container: '.PrescriptionLensData' };

      var data = {
        frameId: this.frame.selectedVariant.id,
        lensId: this.finalVariant.id,
        lensProps: this.lensProps,
        frameProps: {
          '_item_type': 'specs_frame',
          'vision': this.activePrescription.type,
          'lens type': this.finalLens.title,
          'lens option': this.finalVariant.title,
          '_lens_variant_id': this.finalVariant.id,
          '_lens_price': this.finalVariant.price
        },
        customer: customer
      };
      data.lensProps['_vision'] = this.activePrescription.type;
      data.lensProps['_frame'] = this.frame.title;
      data.lensProps['_lens_option'] = this.finalVariant.title;
      if (this.activePrescription.id) {
        data.frameProps['_prescription_id'] = this.activePrescription.id;
        data.lensProps['_prescription_id'] = this.activePrescription.id;
      }

      var cartInstance = new _cart2.default(data);

      _vueScrollto2.default.scrollTo(element, 300, options);
      setTimeout(function () {
        if (_this.activePrescription.id) {
          cartInstance.addLens();
          self.$emit('add-to-cart');
        } else {
          cartInstance.postPrescription(_this.activePrescription, _this.finalLens);
          self.$emit('add-to-cart');
        }
      }, 300);
    },
    returnOptionContent: function returnOptionContent(name) {
      var button = this.optionButtons.filter(function (button) {
        return button.name.toLowerCase().trim() === name.toLowerCase().trim();
      });
      return button.length > 0 ? button[0].content : '';
    },
    returnTintContent: function returnTintContent(name) {
      var button = this.tintMeta.filter(function (button) {
        return button.name.toLowerCase().trim() === name.toLowerCase().trim();
      });
      return button.length > 0 ? button[0].content : '';
    },
    returnOptionsImage: function returnOptionsImage(name) {
      var button = this.optionButtons.filter(function (button) {
        return button.name.toLowerCase().trim() === name.toLowerCase().trim();
      });

      if (button.length > 0) {
        var noImage = button[0].icon.includes('no-image');
        if (noImage) {
          return '';
        } else {
          return button[0].icon;
        }
      } else {
        return '';
      }
    },
    returnTintsImage: function returnTintsImage(name) {
      var button = this.tintMeta.filter(function (button) {
        return button.name.toLowerCase().trim() === name.toLowerCase().trim();
      });

      if (button.length > 0) {
        var noImage = button[0].icon.includes('no-image');
        if (noImage) {
          return '';
        } else {
          return button[0].icon;
        }
      } else {
        return '';
      }
    },
    addTintProp: function addTintProp(button) {
      this.selectedTint = button.name;
      this.nextDisabled = false;
      this.lensProps = { '_tint': button.name };
      this.setFinalVariant(button);
    },
    formattedPrice: function formattedPrice(price) {
      var value = price === 'free' ? '' : 'P' + parseFloat(price / 100).toFixed(2).replace('.00', '');
      return value;
    }
  })
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//